const customMarkNameValues = [
    "app_mounted",
    "app_rendered",
    "cumulative_layout_shift",
    "cumulative_resource_metrics",
    "interaction_to_next_paint",
    "speed_index",
    "time_to_interactive",
    "total_blocking_time",
    "window_load",
] as const;

export type CustomMarkName = (typeof customMarkNameValues)[number];
export const customMarkNames = new Set<CustomMarkName>(customMarkNameValues);
